export const CLAIMANTS_ADDED = 'CLAIMANTS_ADDED';
export const POLICY_ADDED = 'POLICY_ADDED';
export const FR_SAVED = 'FR_SAVED';
export const FR_LIABILITY_SAVED = 'FR_LIABILITY_SAVED';
export const CLAIMENT_TABS_ADDED = 'CLAIMENT_TABS_ADDED';
export const PATH_ADDED = 'PATH_ADDED';
export const MODAL_OPENED = 'MODAL_OPENED';
export const PAGE_TYPE_FR_EDIT = 'fr-edit';
export const PAGE_TYPE_FR_ADD = 'fr-add';
export const PAGE_TYPE_FR_MOVE = 'fr-move';
export const PAGE_TYPE_CLAIMS_EDIT = 'claims-edit';
export const PAGE_TYPE_CLAIMS_ADD = 'claims-add';
export const PAGE_TYPE_FR_VIEW = 'fr-view';
export const PAGE_TYPE_CLAIMS_VIEW = 'claims-view';
export const PAGE_MODE_ADDED = 'PAGE_MODE_ADDED';
export const PAGE_ARGS_ADDED = 'PAGE_ARGS_ADDED';
export const PIP_BILLS_ADDED="PIP_BILLS_ADDED";